import {
    CMS_LIST_ERROR,
    CMS_LIST_SUCCESS,
    CMS_UPDATE_ERROR,
    CMS_UPDATE_SUCCESS,
    CMS_VIEW_ERROR,
    CMS_VIEW_SUCCESS,
    IS_LOADING,
    CATEGORY_LIST_SUCCESS,
    CATEGORY_UPDATE_SUCCESS,
    CATEGORY_UPDATE_ERROR,
    FAQ_LIST_SUCCESS,
    FAQ_UPDATE_SUCCESS,
    FAQ_UPDATE_ERROR,
    FAQ_CREATE_SUCCESS,
    FAQ_CREATE_ERROR
} from "../actions/Type";

const initialState = {
    cms_list: {},
    cms_view: {},
    cms_updated: {},
    loading: false,
    catgeory_list: {},
    create_catgeory: {},
    faq_list: {},
    create_faq: {},
    update_faq: {}
};

export const CMSReducers = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case CMS_LIST_SUCCESS:
            return {
                ...state,
                cms_list: payload,
                loading: false,
            };
        case CMS_LIST_ERROR:
            return {
                ...state,
                cms_list: payload,
                loading: false,
            };

        case CMS_VIEW_SUCCESS:
            return {
                ...state,
                cms_view: payload,
                loading: false,
            };
        case CMS_VIEW_ERROR:
            return {
                ...state,
                cms_view: payload,
                loading: false,
            };

        case CMS_UPDATE_SUCCESS:
            return {
                ...state,
                cms_updated: payload,
                loading: false,
            };
        case CMS_UPDATE_ERROR:
            return {
                ...state,
                cms_updated: payload,
                loading: false,
            };
        case CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                catgeory_list: payload,
                loading: false,
                error: {}
            };
        case CATEGORY_UPDATE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case CATEGORY_UPDATE_SUCCESS:
            return {
                ...state,
                create_catgeory: payload,
                loading: false,
            }
        case FAQ_LIST_SUCCESS:
            return {
                ...state,
                faq_list: payload,
                loading: false,
                error: {}
            };
        case FAQ_UPDATE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case FAQ_UPDATE_SUCCESS:
            return {
                ...state,
                create_faq: payload,
                loading: false,
            }
        case FAQ_CREATE_SUCCESS:
            return {
                ...state,
                update_faq: payload,
                loading: false,
            }
        case FAQ_CREATE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            return state;
    }
};
